import { EventStatus } from '@wix/events-types';
export const UPCOMING_EVENT_STATUSES = [EventStatus.SCHEDULED, EventStatus.STARTED];
export const PAST_EVENT_STATUSES = [EventStatus.ENDED, EventStatus.CANCELED];
export const WIX_FEE_RATE = 0.025;
export const THANK_YOU_MESSAGES_DYNAMIC_GUEST_NAME_PLACEHOLDER = '{Guest Name}';
export const THANK_YOU_MESSAGES_DYNAMIC_EVENT_NAME_PLACEHOLDER = '{Event Name}';
export const THANK_YOU_MESSAGES_DYNAMIC_GUEST_EMAIL_PLACEHOLDER = '{Guest Email}';
export const MIN_EVENT_DATE = '1900-01-01';
export const MAX_LOCATION_NAME_LENGTH = 40;
export const MAX_LOCATION_ADDRESS_LENGTH = 150;
export const MAX_TBD_MESSAGE_LENGTH = 43;
export const CATEGORY_LIMIT = 10;
export const MAX_OCCURRENCES = 200;
export const MAX_POLICIES_ALLOWED = 3;
export const MAX_PRICE_OPTION_AMOUNT = 10;
//# sourceMappingURL=event.js.map